import React from "react";
import CustomDrawer, { CustomDrawerContent, CustomDrawerHeader } from "components/custom-ui/CustomDrawer";
import AccountDetailsView from "components/shared/views/AccountDetailsView";

import "./styles.css";

/**
 * @function MobileAccountDetailsModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the MobileAccountDetailsModal
 */
export default function MobileAccountDetailsModal(props) {
    return (
        <CustomDrawer id="MobileAccountDetailsModal" className="mobile-account-details-modal show-on-mobile">
            <CustomDrawerHeader id="MobileAccountDetailsModal" dataPoint="Account_Details_Modal">
                <span>Account Details</span>
            </CustomDrawerHeader>
            <CustomDrawerContent>
                <AccountDetailsView data={props.data} />
            </CustomDrawerContent>
        </CustomDrawer>
    )
}
